// Third Party
import { faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

// Project
import DerivedDraftButton from "./DerivedDraftButton";

/**
 * Creates a Forward button.
 *
 * @constructor
 * @param {Object} props - Forward button properties
 */
function ForwardButton(props) {
  return (
    <DerivedDraftButton onClick={props.onClick} title="Forward">
      <FontAwesomeIcon icon={faShare} />
    </DerivedDraftButton>
  );
}

ForwardButton.propTypes = {
  onClick: PropTypes.func
};

export default ForwardButton;
